var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.loading)?_c('div',{staticClass:"w-full h-full z-40 fixed top-0 start-0 flex justify-center items-center",attrs:{"dir":_vm.direction}},[_c('loader'),_vm._v(" "),_c('div',{staticClass:"loading-page fixed w-full h-full top-0 start-0 bg-white opacity-75"})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }